import { publicApi } from 'lib/api'
import to from 'lib/to'

export const getProducts = () => to(publicApi.get('/products.json'))
